import React from 'react'
import Svg, { SvgProps } from '@/components/svg'
import iconHouse from '../build/icon-house'

export const IconHouseComponent: React.FC<Omit<SvgProps, 'src'>> = (props) => {
  return <Svg {...props} src={iconHouse} />
}

export default IconHouseComponent
